import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import FieldTimetable from './field-timetable'
import IntervalHeaders from './interval-headers'

class LocationFieldRows extends React.PureComponent {
  scrollToCell() {
    if (this.targetCell) {
      this.scrollableDiv.scrollLeft = this.targetCell.offsetLeft
    }
  }

  componentDidMount() {
    this.scrollToCell()
  }

  render() {
    const {id, fields, date, intervals, isSdAdmin, onEventClicked, onNewEvent} = this.props
    const slots = intervals[id]['slots']
    const firstEvent = slots.find(slot => fields.some(f => f.events[slot.text]))
    const firstEventTime = firstEvent ? firstEvent.text : '6 PM'

    return (
      <div className='col scrollable' ref={e => this.scrollableDiv = e} >
        <table className='location-timetable__table cells' data-id={id}>
          <thead>
            <IntervalHeaders
              intervals={slots}
              refToTime={e => this.targetCell = e}
              firstEventTime={firstEventTime}
            />
          </thead>
          <tbody>
            {fields.map(field =>
              <FieldTimetable 
                key={field.id} id={field.id} date={date} intervals={slots} events={field.events}
                isSdAdmin={isSdAdmin} onEventClicked={onEventClicked} onNewEvent={onNewEvent}
              />
            )}
          </tbody>
        </table>
      </div>
    )
  }
}

LocationFieldRows.propTypes = {
  id: PropTypes.number.isRequired,
  fields: PropTypes.array.isRequired,
  date: PropTypes.string.isRequired,
  intervals: PropTypes.object,
  isSdAdmin: PropTypes.bool,
  onEventClicked: PropTypes.func.isRequired,
  onNewEvent: PropTypes.func.isRequired
}

const mapStateToProps = ({entities: {intervals}}) => ({intervals})

export default connect(mapStateToProps)(LocationFieldRows)
